import { useEffect, useState } from "react";
import { NavLink } from "react-router";

import { IconCompass, IconFolderCheck, IconHamburger, IconLogs, IconUsers } from "@/components/generated/icons";
import { t } from "@/i18n/translate";
import { isNode } from "@/utils/typeChecks";

import cls from "./NavBar.module.css";

export function NavBarMenu() {
  return (
    <div className={cls.navBarMenu}>
      <NavLink to={"/elections"}>
        <IconCompass />
        {t("election.title.plural")}
      </NavLink>
      <NavLink to={"/users"}>
        <IconUsers />
        {t("users.users")}
      </NavLink>
      <NavLink to={"/logs"}>
        <IconLogs />
        {t("logs")}
      </NavLink>
      <NavLink to={"/backups"}>
        <IconFolderCheck />
        {t("backups.backups")}
      </NavLink>
    </div>
  );
}

export function NavBarMenuButton() {
  const [isMenuVisible, setMenuVisible] = useState(false);

  useEffect(() => {
    if (isMenuVisible) {
      const handleClickOutside = (event: MouseEvent) => {
        if (!isNode(event.target) || !document.querySelector(`.${cls.navBarMenu}`)?.contains(event.target)) {
          setMenuVisible(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isMenuVisible]);

  const toggleMenu = () => {
    setMenuVisible(!isMenuVisible);
  };

  return (
    <button className={cls.navBarMenuContainer} onClick={toggleMenu} title={t("menu")} type="button">
      <IconHamburger />
      {isMenuVisible && <NavBarMenu />}
    </button>
  );
}
